import classNames from 'classnames'
import { useField } from '../../Form/hooks/useField'
import { IFieldProps } from '../../Form/types'
import './PhoneInput.scss'
import { Validators } from '../../Form/validation'
import 'react-phone-number-input/style.css'
import PhoneInputLib from 'react-phone-number-input'
import { Country } from 'react-phone-number-input'
import { __ } from '@wordpress/i18n'
import { useLocale } from '../../../hooks/useLocale'

export const PhoneInput = ({ fieldConstructor, anyTouched }: IFieldProps) => {
    fieldConstructor.addValidators([Validators.phone])
    const { placeholder, value, errors, setValue, touched, setTouched, width } =
        useField(fieldConstructor)
    const { localeCode } = useLocale()
    const showError = errors && errors.length > 0 && (anyTouched || touched)
    return (
        <div
            className={classNames('wbk_input wbk_input__phone', {
                'wbk_input--half-width': width === 'half-width',
            })}
        >
            <PhoneInputLib
                placeholder={placeholder || 'Enter phone number'}
                value={value as string}
                onChange={(value) => setValue(value as string)}
                onBlur={() => setTouched(true)}
                className={classNames(
                    'wbk_input__main wbk_input__phone__input',
                    {
                        'wbk_input__main--error': showError,
                    }
                )}
                defaultCountry={localeCode as Country}
            />
            {showError && <div className={'wbk_input__error'}>{errors[0]}</div>}
        </div>
    )
}
